import React from 'react'
import { reactIcon } from '../icons/icons';
import './Home.css';
export const Home = () => {
  return (
    <div className="home">
      {reactIcon}
    </div>
  )
};
